module.exports = __webpack_public_path__ + "img/sampleb.4ef19017.png";